export default "__VITE_ASSET__D6f315sz__"